"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Diagnostic_exports = {};
__export(Diagnostic_exports, {
  default: () => Diagnostic_default
});
module.exports = __toCommonJS(Diagnostic_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.031 3.90071C12.291 3.91416 12.5127 4.09375 12.5797 4.34531L16.0639 17.4109L17.9308 11.8102C18.0125 11.5652 18.2417 11.3999 18.5 11.3999H21.5C21.8314 11.3999 22.1 11.6685 22.1 11.9999C22.1 12.3313 21.8314 12.5999 21.5 12.5999H18.9325L16.5692 19.6896C16.4854 19.9411 16.2466 20.1077 15.9817 20.0996C15.7168 20.0915 15.4885 19.9106 15.4203 19.6545L11.8991 6.45017L8.56069 15.2135C8.48074 15.4234 8.29026 15.571 8.06707 15.5961C7.84388 15.6213 7.62536 15.5196 7.50077 15.3327L5.67889 12.5999H2.5C2.16863 12.5999 1.9 12.3313 1.9 11.9999C1.9 11.6685 2.16863 11.3999 2.5 11.3999H6C6.20061 11.3999 6.38795 11.5002 6.49923 11.6671L7.85364 13.6987L11.4393 4.28631C11.532 4.04302 11.771 3.88726 12.031 3.90071Z",
      fill: "currentColor"
    }
  )
);
const SvgDiagnostic = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Diagnostic_default = SvgDiagnostic;
